import React from 'react';
import { ShieldAlert, HelpCircle } from 'lucide-react';
interface TrustSectionProps {
  onOpenPrivacy?: () => void;
  onOpenTerms?: () => void;
}
export function TrustSection({
  onOpenPrivacy,
  onOpenTerms
}: TrustSectionProps) {
  return <section className="bg-white py-20 px-4" data-id="element-133">
      <div className="max-w-4xl mx-auto" data-id="element-134">
        {/* Guarantee */}
        <div className="bg-zinc-50 border-2 border-zinc-200 rounded-2xl p-8 md:p-12 mb-16 text-center relative overflow-hidden" data-id="element-135">
          <div className="absolute top-0 left-0 w-full h-2 bg-brand-orange" data-id="element-136"></div>
          <ShieldAlert className="w-16 h-16 text-brand-orange mx-auto mb-6" data-id="element-137" />
          <h3 className="text-2xl md:text-3xl font-montserrat font-extrabold text-black mb-4" data-id="element-138">
            60-Day Risk-Free Guarantee
          </h3>
          <p className="text-lg text-zinc-700 leading-relaxed max-w-2xl mx-auto" data-id="element-139">
            Try the system for 60 days. If you don't feel 100% prepared to
            protect your family, email us. We'll refund every cent and you keep
            the bonuses. <strong data-id="element-140">Zero risk.</strong>
          </p>
        </div>

        {/* FAQ */}
        <div className="mb-20" data-id="element-141">
          <div className="flex items-center justify-center gap-3 mb-10" data-id="element-142">
            <HelpCircle className="w-8 h-8 text-black" data-id="element-143" />
            <h3 className="text-3xl font-montserrat font-extrabold text-black" data-id="element-144">
              Frequently Asked Questions
            </h3>
          </div>

          <div className="space-y-6" data-id="element-145">
            <div className="bg-white border border-zinc-200 p-6 rounded-xl shadow-sm" data-id="element-146">
              <h4 className="font-montserrat font-bold text-xl text-black mb-2" data-id="element-147">
                Is this a physical book?
              </h4>
              <p className="text-zinc-600" data-id="element-148">
                No. It's a 100% digital system for instant access on your phone,
                tablet, or computer. (Perfect for access during a crisis when
                you need information immediately).
              </p>
            </div>
            <div className="bg-white border border-zinc-200 p-6 rounded-xl shadow-sm" data-id="element-149">
              <h4 className="font-montserrat font-bold text-xl text-black mb-2" data-id="element-150">
                Do I need a big budget to implement this?
              </h4>
              <p className="text-zinc-600" data-id="element-151">
                No. Most of our strategies cost less than $50 to implement. We
                focus on practical, everyday items rather than expensive
                "survivalist" gear.
              </p>
            </div>
            <br data-id="element-152" />
          </div>
          <div className="flex items-center justify-center gap-3 mb-10" data-id="element-153">
            <h3 className="text-3xl font-montserrat font-extrabold text-black" data-id="element-154">
              You've read this far because you know something needs to change.
            </h3>
          </div>
          <div className="bg-white border border-zinc-200 p-6 rounded-xl shadow-sm" data-id="element-155">
            <p className="font-montserrat font-bold text-xl " data-id="element-156">
              Your family is counting on you. The grid won't wait. The stores
              won't wait. But this $9.99 decision? That one is yours to make
              right now.
            </p>
          </div>
          <br data-id="element-157" />
          <div className="text-center" data-id="element-158">
            <button className="btn-crunchy w-full md:w-auto px-12 py-6 text-xl md:text-2xl mx-auto mb-6" data-id="element-159">
              YES — PROTECT MY FAMILY NOW FOR $9.99
            </button>
            <p className="text-zinc-500 text-sm" data-id="element-160">
              One-time payment. No hidden fees. Instant digital delivery.
            </p>
          </div>
        </div>

        {/* Footer / Disclaimer */}
        <div className="border-t border-zinc-200 pt-8 text-center" data-id="element-161">
          <p className="text-xs text-zinc-400 max-w-2xl mx-auto leading-relaxed" data-id="element-162">
            Disclaimer: Digital access only. No physical shipping. Access
            instructions sent to your email immediately after purchase. The
            information provided is for educational purposes. Always consult
            local laws and professionals regarding home security and medical
            emergencies.
          </p>
          <p className="text-xs text-zinc-400 mt-4" data-id="element-163">
            &copy; {new Date().getFullYear()} The Urban Autonomy System. All
            rights reserved.
          </p>
          <div className="flex justify-center items-center gap-3 mt-4" data-id="element-164">
            <button onClick={onOpenPrivacy} className="text-xs text-zinc-500 underline hover:text-brand-orange cursor-pointer transition-colors" data-id="element-165">
              Privacy Policy
            </button>
            <span className="text-xs text-zinc-300" data-id="element-166">|</span>
            <button onClick={onOpenTerms} className="text-xs text-zinc-500 underline hover:text-brand-orange cursor-pointer transition-colors" data-id="element-167">
              Terms & Conditions
            </button>
          </div>
        </div>
      </div>
    </section>;
}